import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api'
import {
  PublicApiSettingsCreateInterface,
  PublicApiSettingsCreatedInterface,
} from '../types/public-api-settings-interface'

export const useCreatePublicApiKey = () => {
  const { fetcher: postFetcher } = useFetch<
    RequestMethodsEnum.post,
    PublicApiSettingsCreatedInterface
  >({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
  })

  return {
    createPublicApiKey: (data: PublicApiSettingsCreateInterface) =>
      postFetcher(`${PUBLIC_API_SETTINGS}`, data),
  }
}
